import React from 'react';
import { Category } from '@/types';

interface CategorySelectOptionsProps {
  categories: Category[];
  level?: number;
}

export const CategorySelectOptions: React.FC<CategorySelectOptionsProps> = ({
  categories,
  level = 0,
}) => {
  // Don't render options for levels beyond 4
  if (level > 4) {
    return null;
  }

  return (
    <>
      {categories.flatMap((category) => {
        const prefix = '│ '.repeat(level) + (level > 0 ? '├─ ' : '');
        const options = [
          <option 
            key={category.id} 
            value={category.id} 
            className="py-1 px-2 hover:bg-gray-100 dark:hover:bg-gray-800"
            style={{
              backgroundColor: level % 2 === 0 ? 'var(--background)' : 'var(--accent)',
              paddingLeft: `${level * 1.5 + 0.5}rem`
            }}
          >
            {prefix}{category.name} ({category.type})
          </option>
        ];

        if (category.children && category.children.length > 0) {
          options.push(
            <CategorySelectOptions 
              key={`children-${category.id}`} 
              categories={category.children} 
              level={level + 1} 
            />
          );
        }

        return options;
      })}
    </>
  );
};